import type { BytemdSafeMdxViewerPlugin } from '@tarslib/bytemd-processor';
import remarkImageReplaceHost from './remark-image-replace-host';

export default function pluginImageSrcPrefix(
  searchHostname: string[],
  replaceHostname: string,
  customDomainRequestPath?: string,
  isEnterpriseEdition?: boolean,
): BytemdSafeMdxViewerPlugin {
  return {
    remark: (process) => {
      return process.use(
        remarkImageReplaceHost,
        searchHostname,
        replaceHostname,
        customDomainRequestPath,
        isEnterpriseEdition,
      );
    },
  };
}
